// extracted by mini-css-extract-plugin
export var createdDate = "_n9-1";
export var divider = "_n9-2";
export var headerDivider = "_n9-3";
export var messagesCard = "_n9-0";
export var messagesContainer = "_n9-7";
export var messagesContainerWrapper = "_n9-4";
export var pointerCapturingButtonBoxes = "_n9-a";
export var showLeftPanelButton = "_n9-9";
export var showMoreButton = "_n9-c";
export var showMoreButtonContainer = "_n9-b";
export var summaryTitle = "_n9-6";
export var systemMessageCardWrapper = "_n9-d";
export var topButtons = "_n9-8";
export var withPadding = "_n9-5";